<template>
  <mtd-table
    :data="billList"
    bordered
    striped
  >
    <mtd-table-column
      v-for="item in columns"
      :key="item.label"
      v-bind="item"
      head-align="center"
      :min-width="100"
    />
  </mtd-table>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'InvoiceBill',
  data() {
    return {
      billList: [],
      columns: [
        {
          label: '待开票金额',
          prop: 'needInvoicedAmount',
          formatter: (row, col, value) => `${value}元`,
        },
        {
          label: '账单月份',
          prop: 'month',
        },
        {
          label: '账单金额',
          prop: 'billAmount',
          formatter: (row, col, value) => `${value}元`,
        },
        {
          label: '业务类型',
          prop: 'receiptTypeName',
        },
        {
          label: '业务单号',
          prop: 'businessNo',
        },
      ],
    };
  },
  computed: {
    ...mapState('invoiceModule', ['invoiceList']),
  },
  mounted() {
    this.getBillList();
  },
  methods: {
    formatDate(dateStr) {
      const year = dateStr.slice(0, 4);
      const month = dateStr.slice(4);
      return `${year}-${month}`;
    },
    getBillList() {
      const contractBody = this.$route.params.contractBody;
      const selectedContractItem = this.invoiceList.find((item) => (item.contractBody === contractBody));
      const bills = selectedContractItem ? selectedContractItem.detail : [];
      this.billList = bills.map((item) => {
        item.month = this.formatDate(item.month);
        item.members = item.members || [];
        return item;
      });
    },
  },
  beforeRouteEnter(to, from, next) {
    if (to.params.contractBody) {
      document.title = `${document.title}(${to.params.contractBody.slice(0, 4)})`;
    }
    next();
  },
};
</script>
<style lang="scss" scoped>
.invoiceBill-container {
  .info-main-panel {
    margin: 20px;
    padding: 16px 16px 24px;
    background: #ffffff;
    border-radius: 16px;
    .info-item {
      line-height: 48px;
      padding: 10px;
      border-bottom: 1px solid rgba(0, 0, 0, .06);
      .row {
        display: flex;
        justify-content: space-between;
        .left-child {
          margin-left: 15px;
          text-align: left;
        }
        .right {
          min-width: 210px;
        }
      }
      .top-title {
        font-weight: bold;
        margin-bottom: 16px;
      }
    }
  }
}
</style>
